export const research = [
  {
    active: [2021, 2022],
    employer: "Northern Arizona University",
    location: "",
    title: {
      primary:
        "Equality, diversity, and inclusion: Different varieties of accents in Aptis English listening tests",
      secondary: (
        <>
          Role: Research Assistant
          <br />
          PI: Dr. Okim Kang
          <br />
          Funded by: the British Council
        </>
      ),
    },
    responsibilities: [
      "Developed data collection instruments",
      "Developed Python and R scripts for data cleaning and analysis",
      "Research publications",
      "Conducted conference presentations",
    ],
  },
  {
    active: [2021, 2022],
    employer: "Northern Arizona University",
    location: "",
    title: {
      primary:
        "Fairness of using different accents in listening tasks of the Duolingo English Test",
      secondary: (
        <>
          Role: Research Assistant
          <br />
          PI: Dr. Okim Kang
          <br />
          Funded by: Duolingo
        </>
      ),
    },
    responsibilities: [
      "Developed data collection instruments",
      "Developed Python and R scripts for data cleaning and analysis",
      "Research publications",
      "Conducted conference presentations",
    ],
  },
  {
    active: [2021],
    employer: "Northern Arizona University",
    location: "",
    role: "Research Assistant",
    title: {
      primary: "Application of VR Technology to pragmatics task development",
      secondary: (
        <>
          Role: Research Assistant
          <br />
          PI: Dr. Naoko Taguchi
          <br />
        </>
      ),
    },
    responsibilities: [
      "Data transcription and coding",
      "Developmed of R scripts for data analysis",
    ],
  },

  {
    active: [2017, 2018, 2019],
    employer: "Northern Arizona University",
    location: "",
    title: {
      primary:
        "Learning morphology in a new language: Input variability, memory, and transfer",
      secondary: (
        <>
          Role: Research Assistant
          <br />
          PI: Dr. Vedran Dronjic
        </>
      ),
    },
    responsibilities: [
      "Transcribed and analyzed spoken data",
      "Administered working memory measurements using experiment software (LlamaB, KBIT-2) as well as post-task participant questionnaires",
      "Coded and analyzed collected data quantitatively and qualitatively",
      "Managed the paperwork for the experiments",
    ],
  },
  {
    active: [2015, 2016],
    employer: "Bonn University",
    location: "",
    title: {
      primary: "Pragmatics Laboratory",
      secondary: <>Role: Research Assistant</>,
    },
    responsibilities: [
      "Administered pragmatic profiling questionnaires",
      "Helped code empirical data representing participants' pragmatic production",
    ],
  },
];
